
<button class="btn btn-danger ml-auto" (click)="closeModal()" >Close</button>
<p class="">
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis consequatur rem impedit cum saepe, ipsam porro inventore asperiores, deserunt maiores numquam quidem sunt libero magnam dolorem voluptas culpa amet dolore.
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis consequatur rem impedit cum saepe, ipsam porro inventore asperiores, deserunt maiores numquam quidem sunt libero magnam dolorem voluptas culpa amet dolore.
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis consequatur rem impedit cum saepe, ipsam porro inventore asperiores, deserunt maiores numquam quidem sunt libero magnam dolorem voluptas culpa amet dolore.
</p>


